(function() {
    angular
        .module('emarket.commons')
        .factory('Socket', ['$log', '$q', 'Announcer', 'socketFactory', '$auth', 'Auth', 'PATH', 'ENV', function($log, $q, Announcer, socketFactory, $auth, Auth, PATH, ENV) {
            var socket = $q.defer();
            var announcer = Announcer.create();
            var newSocket;

            var createSocket = function(token) {
                var url = PATH.realtime + '?token=' + token;
                url = 'https://realtime.emarket.do' + '?token=' + token;
                var socket = socketFactory({
                    ioSocket: io.connect(url, {
                        secure: true,
                        path: '/socket_realtime',
                        transports: [ 'websocket' ],
                        reconnection: true,
                        autoConnect: true
                    })
                });
                socket.on('connect', function() {
                    $log.info('soccket connected');
                    socket.emit('subscribe',
                        {
                            module: 'chats'
                        },
                        function() {});
                });
                [
                    'connect',
                    'connect_error',
                    'connect_timeout',
                    'reconnect',
                    'reconnect_attempt',
                    'reconnecting',
                    'reconnect_error',
                    'reconnect_failed'
                ].forEach(function(event) {
                    socket.on(event, function() {
                        $log.debug('event from socket %s', event, arguments);
                    });
                });
                return socket;
            };
            if ($auth.isAuthenticated()) {
                var token = $auth.getToken();
                newSocket = createSocket(token);
                socket.resolve(newSocket);
            }
            announcer.on(Auth.events.LOGIN_SUCCESS, function() {
                if (!newSocket) {
                    var token = $auth.getToken();
                    newSocket = createSocket(token);
                    socket.resolve(newSocket);
                }
            });
            return socket.promise;
        }]);
}());
